import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Page,
  RouterLink,
  Text,
} from '../components';
import {
  getUserDetails,
  getCarrier,
} from '../modules/selectors';
import Statistics from './home/Statistics';

const propTypes = {
  bootComplete: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    agentNpn: PropTypes.string,
    token: PropTypes.string,
    userId: PropTypes.string,
    userRole: PropTypes.string,
  }),
  carrier: PropTypes.shape({
    carrierId: PropTypes.number,
    carrierName: PropTypes.string,
  }),
};
const defaultProps = {
  carrier: null,
  user: null,
};

function Home({ user, carrier, bootComplete }) {
  if (user) {
    return (
      <Page title="Admin Portal">
        <div>
          <Text>Welcome to the admin portal.</Text>
        </div>
        {bootComplete && <Statistics />}
      </Page>
    );
  }
  return (
    <Page singleColumn title="Welcome to Bestige">
      <p>
        {` Bestige allows us to replace small pieces of AQE, where
          we want to add support for content modification from the front end.
          The filtering and plan selection is handled by AQE. Bestige handles the plan details.
          However, as far as consumers are concerned, only AQE exists.
          AQE uses Bestige behind the scenes to render the plan details.`}
      </p>
      {['local', 'dev'].includes(process.env.NODE_ENV) && (
        <React.Fragment>
          <p>
            Click below to see the plans supported by this carrier in Bestige.
          </p>
          <Button
            as={RouterLink}
            href={`/carriers/${carrier.carrierId}/plans`}
            fullWidth
            size="jumbo"
          >
            View Plans
          </Button>
        </React.Fragment>
      )}
    </Page>
  );
}

function mapStateToProps(state) {
  return {
    user: getUserDetails(state),
    carrier: getCarrier(state),
    bootComplete: state.bootComplete,
  };
}

Home.propTypes = propTypes;
Home.defaultProps = defaultProps;
export default connect(mapStateToProps)(Home);
